import * as React from "react";
import queryString from "query-string";
import services from "../../../../services";
import $ from 'jquery'
import { Tooltip } from "@material-ui/core";
export const MyCommandCell = props => {
  const {
    dataItem
  } = props;
  const inEdit = dataItem[props.editField];
  const isNewItem = dataItem.NewItem === true; 
  ///// DETALHES ////
  const queryParams = queryString.parse(window.location.search)
  const token = +queryParams.idAuto
  const estado = +queryParams.codEstado
  var DesselagemQuery = queryParams.Desselagem
  console.log(token ,"QUERY")
  if(window.location.search != "" && estado == "2" && DesselagemQuery != "true"){
    return inEdit ? <td className="k-command-cell" style={{display: "none"}}>
      
      <button style={{display: "none"}} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-save-command gridbutton" onClick={() => isNewItem ? props.add(dataItem) : props.update(dataItem)}>
        {isNewItem ? <i className="fas fa-check"></i> : <i className="fas fa-redo"></i>}
      </button>
      
      
      <button style={{display: "none"}} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-cancel-command gridbutton" onClick={() => isNewItem ? props.discard(dataItem) : props.cancel(dataItem)}>
        {isNewItem ? <i className="fas fa-times"></i> : <i className="fas fa-times"></i>}
      </button>
    
    </td> : <td  style={{display: "none"}}className="k-command-cell">
      <button style={{display: "none"}} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary k-grid-edit-command gridbutton" onClick={() => props.edit(dataItem)}>
      <i className="fas fa-edit"></i>
      </button>
      <button style={{display: "none"}} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-remove-command gridbutton" onClick={() => props.remove(dataItem)}>
      <i className="fas fa-trash"></i>
      </button>
    </td>;
  }else{
    return inEdit ? <td className="k-command-cell">
      <Tooltip title="Guardar" color="#808080">
      <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-save-command gridbutton" onClick={() => isNewItem ? props.add(dataItem) : props.update(dataItem)}>
        {isNewItem ? <i className="fas fa-check"></i> : <i className="fas fa-redo"></i>}
      </button>
      </Tooltip>
      <Tooltip title="Apagar" color="#808080">
      <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-cancel-command gridbutton" onClick={() => isNewItem ? props.discard(dataItem) : props.cancel(dataItem)}>
        {isNewItem ? <i className="fas fa-times"></i> : <i className="fas fa-times"></i>}
      </button>
      </Tooltip>
    </td> : <td className="k-command-cell">
    <Tooltip title="Editar" color="#808080">
      <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary k-grid-edit-command gridbutton" onClick={() => props.edit(dataItem)}>
      <i className="fas fa-edit"></i>
      </button>
      </Tooltip>
      <Tooltip title="Remover" color="#808080">
      <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-remove-command gridbutton" onClick={() => props.remove(dataItem)}>
      <i className="fas fa-trash"></i>
      </button>
      </Tooltip>
    </td>;
  }
  
};